import { useEffect, useRef } from 'react'

function getNestedValue(object, path) {
  return path.split('.').reduce((value, key) => value?.[key], object)
}

export function useMultiFieldValidation(methods, fields, fieldsToTrigger = fields) {
  const { formState, trigger, watch } = methods
  const hasMounted = useRef(false)
  const watchedValues = fields.map(field => watch(field))
  const touchedValues = fields.map(field => getNestedValue(formState.touchedFields, field))

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true
      return
    }

    trigger(fieldsToTrigger)
  }, [trigger, ...watchedValues, ...touchedValues])
}
